import React from "react";
import { isTimeFormat } from "../constant";
import { PlaceHolderItem } from "../model";
import PlaceHolderInput from "./PlaceholderInput";

type Props = {
  placeholders: PlaceHolderItem[]
  md: {
    [key: string]: any
  }
}

const PlaceholderFilter: React.FC<Props> = ({ placeholders, md }) => {

  const dateTimeParams = (): PlaceHolderItem[] => {
    const holders = placeholders.filter(p => isTimeFormat(p.format));
    const keys = {};
    holders.forEach(h => { keys[h.name] = 0 });
    return holders.filter(h => {
      if (keys[h.name] > 0) {
        return false;
      }
      keys[h.name]++;
      return true;
    });
  }

  const normalParams = (): PlaceHolderItem[] => {
    const holders = placeholders.filter(p => !isTimeFormat(p.format));
    const keys = {};
    holders.forEach(h => { keys[h.name] = 0 });
    return holders.filter(h => {
      if (keys[h.name] > 0) {
        return false;
      }
      keys[h.name]++;
      return true;
    });
  }

  return <>
    {dateTimeParams().map((param, index) => {
      return <PlaceHolderInput
        key={'key' + index}
        placeholder={param}
        rawDate={true}
        md={md}
      />
    })}
    {normalParams().map((param, index) => {
      return <PlaceHolderInput
        key={'key' + index}
        placeholder={param}
        rawDate={true}
        md={md}
      />
    })}
  </>
}

export default PlaceholderFilter
